import { Outlet } from "@remix-run/react";

export default function LiquidityAdd() {
  return (
    <div className="mx-4 mb-6 xl:container xl:mx-auto">
      <Outlet />
    </div>
  );
}
